import { App, Button, ModalFuncProps } from 'antd';
import React from 'react';
import { CheckOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { v4 as uuidV4 } from 'uuid';
import {
  ManagerPublicationCoverListItemFragment,
  SortEnumType,
  useSetPublicationMainCoverMutation,
} from '../../../../services/apolloGraphqlAppApiClient/models/types';
import { usePublicationCoversManagerStore } from '../../PublicationCoversManagerStoreProvider';

export const SetPublicationMainCoverActionButton = (record: ManagerPublicationCoverListItemFragment) => {
  const {
    modal: { confirm },
    notification: { info },
  } = App.useApp();

  const { getPublicationCoversLazy, historyParams } = usePublicationCoversManagerStore();
  const infoKey = uuidV4();

  const [setPublicationMainCover] = useSetPublicationMainCoverMutation({
    onCompleted: (result) => {
      getPublicationCoversLazy({
        variables: {
          where: {
            typeId: { eq: historyParams?.typeId },
            publicationId: { eq: historyParams?.publicationId },
          },
          order: { createdAt: SortEnumType.Desc },
        },
      });
      info({
        placement: 'topRight',
        message: `Set main Cover status: true`,
        key: infoKey,
        duration: 7,
      });
    },
    onError: (e) => {
      return e;
    },
  });

  const handleOk: ModalFuncProps['onOk'] = () => {
    setPublicationMainCover({
      variables: {
        input: { id: record.id, publicationId: record.publicationId, type: record.typeId },
      },
    });
  };

  return (
    <Button
      type="link"
      icon={<CheckOutlined />}
      disabled={record.isMain}
      onClick={() => {
        confirm({
          title: `Are you sure to set this cover as main?`,
          icon: <ExclamationCircleOutlined />,
          okText: 'Set main',
          onOk: handleOk,
          closable: true,
        });
      }}
    >
      Set Main
    </Button>
  );
};
